
export const prices = {
  title: "Preços 2026-2027",
  monthlyFees: {
    title: "Mensalidades",
    subtitle: "10 pagamentos/ano · Inclui ensino e materiais",
    tableHeaders: {
      level: "Nível",
      firstChild: "1º filho/a",
      secondChild: "2º filho/a",
      thirdChild: "3º filho/a"
    },
    infantil: {
      title: "INFANTIL",
      ageRange: "3 a 5 anos",
      schedule: "8:45 às 14:00"
    },
    primaryC1: {
      title: "PRIMÁRIA C1",
      ageRange: "6 a 8 anos",
      schedule: "8:45 às 14:00"
    },
    primaryC2: {
      title: "PRIMÁRIA C2",
      ageRange: "9 a 11 anos",
      schedule: "8:45 às 14:00"
    }
  },
  enrollment: {
    title: "Matrícula",
    description: "A matrícula inclui reserva de vaga, gestão administrativa e avaliação inicial",
    renewal: {
      title: "Renovação (famílias atuais)",
      subtitle: "Matrícula anual para confirmar vaga",
      price: "350€",
      note: "Igual para todos os irmãos"
    },
    newStudents: {
      title: "Novos Alunos",
      subtitle: "Matrícula primeiro ano",
      firstChild: {
        title: "Primeiro filho/a",
        price: "700€"
      },
      siblings: {
        title: "2º e 3º filho/a",
        price: "350€"
      }
    }
  },
  specialDiscounts: {
    title: "Descontos Especiais",
    earlyEnrollment: {
      title: "Matrícula Antecipada",
      description: "Realize sua matrícula antes de 23 de fevereiro e economize 50€ por criança",
      badge: "-50€"
    },
    annualPayment: {
      title: "Pagamento Anual",
      description: "Pague o ano completo antecipadamente e obtenha 200€ de desconto + 200€ em voucher para aniversários ou acampamentos",
      badges: {
        discount: "-200€",
        voucher: "+200€ voucher"
      }
    }
  },
  discounts: {
    title: "Descontos por Irmãos",
    description: "Descontos aplicados automaticamente nas mensalidades",
    secondChild: {
      title: "Segundo filho/a",
      description: "20% de desconto na mensalidade"
    },
    thirdChild: {
      title: "Terceiro filho/a e seguintes",
      description: "40% de desconto na mensalidade"
    }
  },
  additionalServices: {
    title: "Serviços Adicionais",
    transport: {
      title: "Táxi desde Vigo",
      description: "Táxi desde Vigo. Mínimo de 4 lugares. É o único serviço com compromisso de reserva de todo o trimestre; o preço indicado é mensal.",
      roundTrip: {
        title: "Ida e volta",
        price: "225€/mês"
      }
    },
    earlyBirds: {
      title: "Acolhimento Matinal",
      monthly: {
        title: "Mensal",
        price: "75 €"
      },
      daily: {
        title: "Dia avulso",
        price: "7€"
      },
      description: "Serviço diário a partir das 8:15"
    },
    food: {
      title: "Refeitório",
      monthly: {
        title: "5 dias/semana",
        price: "195€"
      },
      threeDays: {
        title: "3 dias/semana",
        price: "125€"
      },
      twoDays: {
        title: "2 dias/semana",
        price: "90€"
      },
      daily: {
        title: "Dia avulso",
        price: "15€"
      },
      description: "Menu elaborado por nutricionista com produtos orgânicos Os planos de refeitório são reservados e pagos mensalmente. Escolhe 5, 3 ou 2 dias fixos por semana. Incluem ludoteca até às 17:00 (sexta até às 16:00). Dias avulsos: avisar com 48 horas de antecedência.",
      takeaway: {
        title: "Comida para viagem",
        description: "Pelo mesmo preço também pode encomendar comida para recolher a qualquer momento entre as 14:00h e as 17:00h. O recipiente é fornecido pela Gándara."
      }
    },
    ludoteca: {
      title: "Ludoteca",
      schedule: "Horário: 15:00 às 17:00 (sexta até às 16:00)",
      freeService: "Gratuito com almoço ou extracurriculares",
      dayPass: {
        title: "Dia avulso"
      },
      oneDay: {
        title: "Um dia/semana"
      },
      twoDays: {
        title: "Dois dias/semana"
      },
      fiveDays: {
        title: "Cinco dias/semana"
      },
      description: "Serviço de cuidados e atividades após o horário escolar"
    }
  },
  preEnrollment: {
    title: "Pronto/a para dar o próximo passo?",
    subtitle: "Junte-se à nossa comunidade educativa em 3 passos simples",
    steps: "Pré-inscrição → Visita guiada → Matrícula",
    ctaPrimary: "Solicitar Pré-inscrição",
    ctaSecondary: "Agendar uma Visita",
    note: "O formulário de pré-inscrição não implica compromisso"
  }
};
